// extracted by mini-css-extract-plugin
export var active = "_hb-2";
export var recordingDot = "_hb-1";
export var recordingIndicator = "_hb-0";